import Panel from './Panel';

const PrimaryOutlinedPanel = (props) => {
    return <Panel {...props} type="outlined" />;
};

export default PrimaryOutlinedPanel;
